 @if (lineHeight() > 0) {
  <div 
    class="transport-list-card__line--walk"
    [style.--line-height.px]="lineHeight()"
  >
    @for(point of getArrayAccordingToTheNumberOfPointsForWalkTransfer(lineHeight()); 
        track point) {
      <span class="line__point"></span>
    }
  </div>
}